!(function () {
    function e() {
        window.__lpCartUpdating ||
            ((window.__lpCartUpdating = !0),
            fetch("/cart.js?t=1", {
                headers: { Accept: "application/json", "X-LP-Skip-Cart-Hook": "1" },
                credentials: "same-origin",
            })
                .then(function (e) {
                    return e.json();
                })
                .then(function (e) {
                    !(function (e) {
                        var t = document.getElementById("cartNotice"),
                            n = document.getElementById("money-left"),
                            o = document.querySelectorAll(".to-free-shipping"),
                            i = 7500;
                        if (e > 1 && e < i) {
                            var r = (i - e) / 100;
                            r = Math.max(0, r);
                            var c = (Math.round(100 * r) / 100).toFixed(2).replace(/\.00$/, ""),
                                s = "Spend $" + c + " to reach $75 & qualify for free shipping";
                            t && ((t.textContent = s), (t.style.display = "block")),
                                n && (n.textContent = c),
                                o.forEach(function (e) {
                                    e.style.display = "block";
                                });
                        } else
                            t && (t.style.display = "none"),
                                o.forEach(function (e) {
                                    e.style.display = "none";
                                });
                    })(e.items_subtotal_price);
                })
                .catch(function () {})
                .finally(function () {
                    setTimeout(function () {
                        window.__lpCartUpdating = !1;
                    }, 50);
                }));
    }
    (window.setCookie =
        window.setCookie ||
        function (e, t, n) {
            var o = "";
            if (n) {
                var i = new Date();
                i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3), (o = "; expires=" + i.toUTCString());
            }
            document.cookie = e + "=" + (t || "") + o + "; path=/";
        }),
        (window.getCookie =
            window.getCookie ||
            function (e) {
                for (var t = e + "=", n = document.cookie.split(";"), o = 0; o < n.length; o++) {
                    for (var i = n[o]; " " === i.charAt(0); ) i = i.substring(1, i.length);
                    if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
                }
                return null;
            }),
        (window.sidebarMenu =
            window.sidebarMenu ||
            function () {
                const e = document.getElementById("blog-sidebar");
                e && e.classList.toggle("show");
            }),
        (function () {
            var e = document.links;
            for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t];
                n &&
                    n.hostname &&
                    n.hostname !== window.location.hostname &&
                    ((n.target = "_blank"), n.relList.add("noreferrer", "noopener"));
            }
        })(),
        document.querySelectorAll(".gifts .has-sub-dropdown").forEach(function (e) {
            function t() {
                const t = e.parentElement;
                t &&
                    t.querySelectorAll("li:not(.sub-dropdown-item) > a").forEach(function (e) {
                        e.classList.toggle("opacity");
                    });
            }
            e.addEventListener("mouseenter", t), e.addEventListener("mouseleave", t);
        }),
        document.addEventListener("DOMContentLoaded", function () {
            e(),
                (function () {
                    if (!window.__lpCartFetchHooked) {
                        window.__lpCartFetchHooked = !0;
                        const t = window.fetch.bind(window);
                        window.fetch = function () {
                            const n = arguments;
                            let o = "",
                                i = null;
                            try {
                                (o = "string" == typeof n[0] ? n[0] : (n[0] && n[0].url) || ""),
                                    n[0] && n[0].headers && (i = n[0].headers),
                                    !i && n[1] && n[1].headers && (i = n[1].headers);
                            } catch (e) {}
                            const r =
                                    (i && "function" == typeof i.get && "1" === i.get("X-LP-Skip-Cart-Hook")) ||
                                    (i && "1" === i["X-LP-Skip-Cart-Hook"]) ||
                                    (i && "1" === i["x-lp-skip-cart-hook"]),
                                c = t.apply(null, n);
                            return r
                                ? c
                                : "string" == typeof o && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(o)
                                  ? c.then(function (t) {
                                        return setTimeout(e, 80), t;
                                    })
                                  : c;
                        };
                    }
                    if (!window.__lpCartObserverHooked) {
                        window.__lpCartObserverHooked = !0;
                        const t = [
                            document.getElementById("cart-notification"),
                            document.querySelector("cart-notification"),
                            document.getElementById("CartDrawer"),
                            document.querySelector("cart-drawer"),
                        ].filter(Boolean);
                        if (!t.length) return;
                        const n = (e) =>
                                !(!e || 1 !== e.nodeType) &&
                                ("cartNotice" === e.id ||
                                    "money-left" === e.id ||
                                    e.classList?.contains("to-free-shipping")),
                            o = (e) => {
                                if ("childList" !== e.type) return !1;
                                const t = e.addedNodes && e.addedNodes.length,
                                    o = e.removedNodes && e.removedNodes.length;
                                if (!t && !o) return !1;
                                if (e.addedNodes)
                                    for (const t of e.addedNodes) {
                                        if (n(t)) return !1;
                                        if (
                                            t &&
                                            t.querySelector &&
                                            t.querySelector("#cartNotice, #money-left, .to-free-shipping")
                                        )
                                            return !1;
                                    }
                                return !0;
                            },
                            i = new MutationObserver(function (t) {
                                window.__lpCartUpdating ||
                                    (t.some(o) &&
                                        (window.__lpCartObserverTimer && clearTimeout(window.__lpCartObserverTimer),
                                        (window.__lpCartObserverTimer = setTimeout(e, 120))));
                            });
                        t.forEach(function (e) {
                            i.observe(e, { childList: !0, subtree: !0 });
                        });
                    }
                    document.addEventListener(
                        "toggle",
                        function (t) {
                            const n = t.target;
                            n &&
                                (("CartDrawer" !== n.id &&
                                    "CART-DRAWER" !== n.tagName &&
                                    "cart-notification" !== n.id &&
                                    "CART-NOTIFICATION" !== n.tagName) ||
                                    setTimeout(e, 80));
                        },
                        !0
                    );
                })(),
                (function () {
                    const e = document.getElementById("btn-blogsearch");
                    e &&
                        e.addEventListener("click", function () {
                            const e = this.closest("form");
                            e && e.submit();
                        });
                })(),
                (function () {
                    const e = document.querySelectorAll(
                        ".drawer-menu__list-item > disclosure-menu > details > summary > div > .mobile-nav-el"
                    );
                    if (!e.length) return;
                    const t = document.querySelector(".menu-drawer__account"),
                        n = document.querySelector(".nav-costumer"),
                        o = document.querySelector(".mobile-close"),
                        i = document.querySelector(".menu-drawer__navigation");
                    e.forEach((e) => {
                        e.addEventListener("click", function (e) {
                            const r = e.currentTarget,
                                c = r.closest("ul");
                            if (!c) return;
                            const s = c.querySelectorAll("li");
                            r.closest("details[open]")
                                ? (s.forEach((e) => e.classList.remove("hide")),
                                  t && t.classList.remove("hide"),
                                  n && n.classList.remove("hide"),
                                  o && o.classList.remove("hide"),
                                  i && i.classList.remove("hide"))
                                : (s.forEach((e) => e.classList.add("hide")),
                                  t && t.classList.add("hide"),
                                  n && n.classList.add("hide"),
                                  o && o.classList.add("hide"),
                                  i && i.classList.add("hide"),
                                  r.closest("li")?.classList.remove("hide"));
                        });
                    });
                })();
        });
})();
